export const getFractionalWidth = (count: number) => {
  return `${(100 / count).toFixed(2)}%`;
};
